module.exports = __webpack_public_path__ + "img/xq-dark.3369d36.png";